import jsPDF from "jspdf";

const A4_WIDTH = 210;
const A4_HEIGHT = 297;
const MARGIN_X = 15;
const MARGIN_Y = 18;
const CONTENT_WIDTH = A4_WIDTH - MARGIN_X * 2;

function stripMarkdown(text) {
  return text
    .replace(/\*\*(.+?)\*\*/g, "$1")
    .replace(/\*(.+?)\*/g, "$1")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/^#+\s+/gm, "")
    .replace(/^- /gm, "• ")
    .replace(/^\s*[-*]\s+/gm, "• ");
}

export function exportAntisechePDF(answers, { title = "Antisèche AIS — Oral" } = {}) {
  const entries = Object.values(answers).sort((a, b) => a.ts - b.ts);
  if (entries.length === 0) return false;

  const doc = new jsPDF({ unit: "mm", format: "a4" });
  let y = MARGIN_Y;

  const newPageIfNeeded = (needed) => {
    if (y + needed > A4_HEIGHT - MARGIN_Y) {
      doc.addPage();
      y = MARGIN_Y;
      drawFooter();
    }
  };

  const drawHeader = () => {
    doc.setFillColor(9, 9, 11);
    doc.rect(0, 0, A4_WIDTH, 24, "F");
    doc.setTextColor(56, 189, 248);
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.text("AIS · ORAL", MARGIN_X, 10);
    doc.setTextColor(161, 161, 170);
    doc.setFont("helvetica", "normal");
    doc.text("Préparation jury — antisèche IA", MARGIN_X, 16);
    doc.setTextColor(113, 113, 122);
    doc.setFontSize(8);
    const date = new Date().toLocaleDateString("fr-FR");
    doc.text(date, A4_WIDTH - MARGIN_X, 16, { align: "right" });
  };

  const drawFooter = () => {
    const page = doc.internal.getCurrentPageInfo().pageNumber;
    doc.setTextColor(113, 113, 122);
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(
      `Page ${page} · AIS Oral Prep`,
      A4_WIDTH / 2,
      A4_HEIGHT - 8,
      { align: "center" }
    );
  };

  // Cover
  drawHeader();
  y = 38;
  doc.setTextColor(244, 244, 245);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text(title, MARGIN_X, y);
  y += 10;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(161, 161, 170);
  const intro = `Document généré le ${new Date().toLocaleString(
    "fr-FR"
  )} contenant ${entries.length} réponse${
    entries.length > 1 ? "s" : ""
  } IA sauvegardée${entries.length > 1 ? "s" : ""}.`;
  const introLines = doc.splitTextToSize(intro, CONTENT_WIDTH);
  doc.text(introLines, MARGIN_X, y);
  y += introLines.length * 6 + 6;

  doc.setDrawColor(56, 189, 248);
  doc.setLineWidth(0.6);
  doc.line(MARGIN_X, y, MARGIN_X + 40, y);
  y += 10;

  // Index
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(244, 244, 245);
  doc.text("Sommaire", MARGIN_X, y);
  y += 7;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(161, 161, 170);
  entries.forEach((entry, i) => {
    newPageIfNeeded(6);
    const line = `${String(i + 1).padStart(2, "0")}. ${entry.questionText}`;
    const wrapped = doc.splitTextToSize(line, CONTENT_WIDTH);
    doc.text(wrapped, MARGIN_X, y);
    y += wrapped.length * 5 + 1;
  });

  drawFooter();

  // Content pages
  entries.forEach((entry, i) => {
    doc.addPage();
    y = MARGIN_Y;
    drawHeader();
    y = 34;

    doc.setFontSize(8);
    doc.setTextColor(56, 189, 248);
    doc.setFont("helvetica", "bold");
    doc.text(
      `${entry.sectionTitle.toUpperCase()} · ${entry.groupTitle.toUpperCase()}`,
      MARGIN_X,
      y
    );
    y += 6;

    doc.setTextColor(244, 244, 245);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    const qLines = doc.splitTextToSize(
      `${String(i + 1).padStart(2, "0")}. ${entry.questionText}`,
      CONTENT_WIDTH
    );
    doc.text(qLines, MARGIN_X, y);
    y += qLines.length * 6 + 4;

    doc.setDrawColor(39, 39, 42);
    doc.line(MARGIN_X, y, MARGIN_X + CONTENT_WIDTH, y);
    y += 6;

    doc.setTextColor(63, 63, 70);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10.5);
    doc.setTextColor(50, 50, 55);
    const body = stripMarkdown(entry.answer);
    const bodyLines = doc.splitTextToSize(body, CONTENT_WIDTH);
    bodyLines.forEach((line) => {
      newPageIfNeeded(6);
      doc.text(line, MARGIN_X, y);
      y += 5.5;
    });

    drawFooter();
  });

  doc.save(`antiseche-AIS-${Date.now()}.pdf`);
  return true;
}
